import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAppState } from '../../state/app.state';
import { IPortfoliosState } from '../../state/portfolios.state';

export const getPortfoliosState = createFeatureSelector<IAppState, IPortfoliosState>('portfolios');

export const getSelectedPortfolioEntity = createSelector(getPortfoliosState, (state: IPortfoliosState) => state.selectedPortfolioEntity);

export const getAvailablePortfolios = createSelector(getPortfoliosState, (state: IPortfoliosState) => state.availablePortfolios);

export const getEntitiesPortfolios = createSelector(getPortfoliosState, (state: IPortfoliosState) => state.entitiesPortfolios);

export const getReferenceNumbers = createSelector(getPortfoliosState, (state: IPortfoliosState) => state.investorReferenceNumbers);

export const getPortfolioLoadingState = createSelector(getPortfoliosState, (state: IPortfoliosState) => state.loading);
